export enum WorkOrderSort {
  DATE_ASSIGNED = 'date_assigned',
  NEWEST_EDITED = 'newest_edited',
  OLDEST_EDITED = 'oldest_edited',
  TITLE_ASC = 'title_asc',
  TITLE_DESC = 'title_desc',
}
